import { FormErrors } from 'redux-form';

const validate = (
  values: ArmyListCreateParams,
): FormErrors<ArmyListCreateParams> => {
  const errors: FormErrors<ArmyListCreateParams> = {};

  if (!values.versionId) {
    errors.versionId = 'army_list.form.version.error';
  }

  if (!values.armyId) {
    errors.armyId = 'army_list.form.army.error';
  }

  if (!values.max) {
    errors.max = 'army_list.form.max.error';
  }

  if (!values.name) {
    errors.name = 'army_list.form.name.error';
  }

  return errors;
};
export default validate;

export interface ArmyListCreateParams {
  versionId: number;
  armyId: number;
  max: number;
  name: string;
  folderId: string | null;
  isPrivate: boolean;
  notes: string | null;
}
